export class CollectionSegmentInfo {
    hasNextPage = true;
    hasPreviousPage = false;
}
